/**
 * QUEM PEDE OS CADASTROS DE APOIO (`GET /equipamentos/apoio/cadastros`).
 *
 * A rota exige `cadastro.ler`, e só serve aos formulários de AÇÃO da frota —
 * cadastrar equipamento (`equipamento.gerir`), alocar (`alocacao.gerir`) e
 * ajustar a ficha (`equipamento.gerir`). Achado dos robôs no QAS (20/10/2026):
 * a Oficina e o Operador abriam `/equipamentos/novo` (ou o detalhe da máquina)
 * e a tela pedia o apoio ANTES de conferir a licença da ação — 403 na rede,
 * colhido pela tela seguinte (o combustível), para um formulário que nem ia
 * aparecer. A consulta só liga com as duas licenças: a da ação e a da rota.
 */
export const LICENCA_DO_APOIO = 'cadastro.ler';

export function apoioLigado(permissoes: readonly string[] | undefined, acao: string): boolean {
  return permissoes !== undefined && permissoes.includes(acao) && permissoes.includes(LICENCA_DO_APOIO);
}
